/**
 * Where the current text selection is, when it lies inside one of `elements`: {index, from, to} — the
 * element's place in the list and character offsets into its text (counted across any <mark> a search added).
 * Null when nothing is selected, or the selection is outside the elements or spans two of them. The picker's
 * Cite button reads this to quote only the selected words.
 */
export function readSelection(elements) {
  const selection = typeof window !== 'undefined' && window.getSelection ? window.getSelection() : null;
  if (!selection || selection.rangeCount === 0 || selection.isCollapsed) return null;
  const range = selection.getRangeAt(0);
  for (let index = 0; index < elements.length; index += 1) {
    const el = elements[index];
    if (!el || !el.contains(range.startContainer) || !el.contains(range.endContainer)) continue;
    const before = document.createRange();
    before.selectNodeContents(el);
    before.setEnd(range.startContainer, range.startOffset);
    const from = before.toString().length;
    return { index, from, to: from + range.toString().length };
  }
  return null;
}
